export const descData = {
  word1: '我怎么这么好看，在我梦中的婚礼上',
  word2: '新郎气质跟红毯不搭，帮我换一个试试吧',
  word3: '确认过眼神，遇见对的人。你，在哪儿？',
  word4: '梦想过很多次婚礼，要不要和我再办一次？',
  word5: '没有婚礼的婚姻可以幸福，但不完整',
  word6: '婚礼，定格的是幸福，跟钱没关系',
  word7: '谁再说我是单身狗，我就跟狗结婚',
  word8: '别瞎耽误功夫了，带我去旅行结婚吧',
  word9: '现在这点爱，别的不够，结婚足够了',
  word10: '我想结婚很久了，你愿意跟我一起吗？',
  word11: '婚礼不可以随便，选个场景才浪漫',
  word12: '搞对象难，结婚难，预想婚礼现场，很简单',
  word13: '我想办场轰轰烈烈的婚礼，你来当新郎，好吗？'
}
